module.exports = __webpack_public_path__ + "img/img5.1220423b.jpg";